import { Navigate } from "react-router-dom";
import { StorageGetItem } from "./StorageComp";
import Unauthorized from "./401";
import dayjs from "dayjs";

export const authData = () => {
  const authData = StorageGetItem("bookAuthData");
  if (authData) {
    return JSON.parse(authData);
  } else {
    return null;
  }
}

export const isAuthenticate = () => {
  const authData = StorageGetItem("bookAuthData");
  if (authData) {
    return true;
  } else {
    return false;
  }
};

export const withAdminAuth = (WrappedComponent) => {
  return (props) => {
    if (typeof window !== "undefined") {
      const authData = StorageGetItem("bookAuthData");

      if (authData) {
        let authDataArr = JSON.parse(authData);

        const currentPath = window.location.pathname;
        if (currentPath.includes("/subscribe") || currentPath.includes("/subscribe-success") || currentPath.includes("/my-profile") || currentPath.includes("/dashboard") || currentPath.includes("/company-profile")) {
          return <WrappedComponent {...props} />;
        }

        if (authDataArr && (authDataArr?.user_type === 1 || (authDataArr?.subscription && authDataArr?.subscription?.end_date && dayjs().isBefore(dayjs(authDataArr?.subscription?.end_date).add(1, 'day'), "day")))) {
          if (authDataArr?.user_type === 3) {
            return <Navigate to={"/driver/today-request-list"} />;
          } else {
            let isPagePerm = false;
            if (authDataArr?.permissions?.indexOf(props?.permission) > -1) {
              isPagePerm = true;
            }
            return authDataArr?.user_type === 1 || authDataArr?.user_type === 2 || isPagePerm ? (<WrappedComponent {...props} />) : (<Unauthorized />);
          }
        } else {
          return <Navigate to={"/subscribe"} />;
        }
      } else {
        return <Navigate to={"/sign-in"} replace />;
      }
    }
    return null;
  };
}

export const getCompanySlug = () => {
  const authData = StorageGetItem("bookAuthData");
  let companySlugTemp = 'app';

  if (authData) {
    let auth = JSON.parse(authData);

    if (auth?.company) {
      if (auth?.company?.url_token) {
        if (auth?.company?.url_token !== '') {
          companySlugTemp = auth?.company?.url_token;
        }
      }
    }
  }

  return companySlugTemp;
}